import { DATE_TIME_FORMATS } from "@miplatform/constants";
import { formatDate, subtractFromBusinessDate } from "@miplatform/utils";
import { getRecipientName } from "./emailFormUtil";

const JOB_READY_EMAIL = "jobready@cathedralplumbingtx.com";

export const getTrimDayOneSubject = (order) =>
  `Confirmation Request for Plumbing TRIM Will Be Ready on ${formatDate(
    order.approvedStartDate,
    DATE_TIME_FORMATS.FORMAT_M_DD
  )}`;

export const getTrimDayOneDetails = (recipients, order) => {
  const recipientNames = getRecipientName(recipients);
  const approvedStartDate = formatDate(
    order.approvedStartDate,
    DATE_TIME_FORMATS.FORMAT_M_DD
  );
  const confirmationDate = formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 1),
    DATE_TIME_FORMATS.FORMAT_M_DD
  );

  return `${recipientNames},\n\nCould you please VERIFY and CONFIRM if the following items will be completed to make the house 100% ready for Plumbing TRIM on ${approvedStartDate}:
• Floors Installed\n• Tops Installed\n• Tiles Installed\n\nIn order to keep the TRIM on the original scheduled date ${approvedStartDate}, please reply via email to ${JOB_READY_EMAIL} by 10AM on ${confirmationDate} to confirm.`;
};

export const getTrimDayTwoSubject = (order) =>
  `Confirmation Request for Plumbing TRIM Will Be Ready to Move Up to ${formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 1),
    DATE_TIME_FORMATS.FORMAT_M_DD
  )}`;

export const getTrimDayTwoDetails = (recipients, order) => {
  const recipientNames = getRecipientName(recipients);
  const approvedStartDate = formatDate(
    order.approvedStartDate,
    DATE_TIME_FORMATS.FORMAT_M_DD
  );
  const moveUpDate = formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 1),
    DATE_TIME_FORMATS.FORMAT_M_DD
  );
  const confirmationDate = formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 2),
    DATE_TIME_FORMATS.FORMAT_M_DD
  );

  return `${recipientNames},\n\nCould you please VERIFY and CONFIRM if the following items will be completed to make the house 100% ready for Plumbing TRIM on ${moveUpDate}:
• Floors Installed\n• Tops Installed\n• Tiles Installed\n\nWe are currently showing this TRIM scheduled for ${approvedStartDate}.
Please reply via email to ${JOB_READY_EMAIL} by 10AM on ${confirmationDate} to confirm and we will move this TRIM up to ${moveUpDate} if we have the availability.
<b style="color: red">Confirming READY EARLY does NOT GUARANTEE this home will be MOVED UP from the original schedule date.</b>\n
Thank you for your understanding!`;
};

export const getTopOutDayOneSubject = (order) =>
  `Confirmation Request for Plumbing TOPOUT Will Be Ready on ${formatDate(
    order.approvedStartDate,
    DATE_TIME_FORMATS.FORMAT_M_DD
  )}`;

export const getTopOutDayOneDetails = (recipients, order) => {
  const recipientNames = getRecipientName(recipients);
  const approvedStartDate = formatDate(
    order.approvedStartDate,
    DATE_TIME_FORMATS.FORMAT_M_DD
  );
  const confirmationDate = formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 1),
    DATE_TIME_FORMATS.FORMAT_M_DD
  );

  return `${recipientNames},\n\nCould you please VERIFY and CONFIRM if the following items will be completed to make the house 100% ready for Plumbing TOPOUT on ${approvedStartDate}:
• Corniced Done\n• Gas Drops Locations are Marked On Site for Gas Homes\n\nIn order to keep the TOPOUT on the original scheduled date ${approvedStartDate}, please reply via email to ${JOB_READY_EMAIL} by 10AM on ${confirmationDate} to confirm.`;
};

export const getTopOutDayTwoSubject = (order) =>
  `Confirmation Request for Plumbing TOPOUT Will Be Ready to Move Up to ${formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 1),
    DATE_TIME_FORMATS.FORMAT_M_DD
  )}`;

export const getTopOutDayTwoDetails = (recipients, order) => {
  const recipientNames = getRecipientName(recipients);
  const approvedStartDate = formatDate(
    order.approvedStartDate,
    DATE_TIME_FORMATS.FORMAT_M_DD
  );
  const moveUpDate = formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 1),
    DATE_TIME_FORMATS.FORMAT_M_DD
  );
  const confirmationDate = formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 2),
    DATE_TIME_FORMATS.FORMAT_M_DD
  );

  return `${recipientNames},\n\nCould you please VERIFY and CONFIRM if the following items will be completed to make the house 100% ready for Plumbing TOPOUT on ${moveUpDate}:
• Corniced Done\n• Gas Drops Locations are Marked On Site for Gas Homes\n\nWe are currently showing this TOPOUT scheduled for ${approvedStartDate}.
Please reply via email to ${JOB_READY_EMAIL} by 10AM on ${confirmationDate} to confirm and we will move this TOPOUT up to ${moveUpDate} if we have the availability.
<b style="color: red">Confirming READY EARLY does NOT GUARANTEE this home will be MOVED UP from the original schedule date.</b>\n
Thank you for your understanding!`;
};

export const getRoughBuilderSandDayOneSubject = (order) =>
  `Confirmation Request for Plumbing ROUGH Will Be Ready on ${formatDate(
    order.approvedStartDate,
    DATE_TIME_FORMATS.FORMAT_M_DD
  )}`;

export const getRoughBuilderSandDayOneDetails = (recipients, order) => {
  const recipientNames = getRecipientName(recipients);
  const approvedStartDate = formatDate(
    order.approvedStartDate,
    DATE_TIME_FORMATS.FORMAT_M_DD
  );
  const confirmationDate = formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 1),
    DATE_TIME_FORMATS.FORMAT_M_DD
  );

  return `${recipientNames},\n\nCould you please VERIFY and CONFIRM if the following items will be completed to make the house 100% ready for Plumbing ROUGH on ${approvedStartDate}:
• Sand is On Site\n• Water Meter Installed\n• Form Survey Completed\n• Trenching Completed\n\nIn order to keep the ROUGH on the original scheduled date ${approvedStartDate}, please reply via email to ${JOB_READY_EMAIL} by 10AM on ${confirmationDate} to confirm.`;
};

export const getRoughBuilderSandDayTwoSubject = (order) =>
  `Confirmation Request for Plumbing ROUGH Will Be Ready to Move Up to ${formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 1),
    DATE_TIME_FORMATS.FORMAT_M_DD
  )}`;

export const getRoughBuilderSandDayTwoDetails = (recipients, order) => {
  const recipientNames = getRecipientName(recipients);
  const approvedStartDate = formatDate(
    order.approvedStartDate,
    DATE_TIME_FORMATS.FORMAT_M_DD
  );
  const moveUpDate = formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 1),
    DATE_TIME_FORMATS.FORMAT_M_DD
  );
  const confirmationDate = formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 2),
    DATE_TIME_FORMATS.FORMAT_M_DD
  );

  return `${recipientNames},\n\nCould you please VERIFY and CONFIRM if the following items will be completed to make the house 100% ready for Plumbing ROUGH on ${moveUpDate}:
• Sand is On Site\n• Water Meter Installed\n• Form Survey Completed\n• Trenching Completed\n\nWe are currently showing this ROUGH scheduled for ${approvedStartDate}.
Please reply via email to ${JOB_READY_EMAIL} by 10AM on ${confirmationDate} to confirm and we will move this ROUGH up to ${moveUpDate} if we have the availability.
<b style="color: red">Confirming READY EARLY does NOT GUARANTEE this home will be MOVED UP from the original schedule date.</b>\n
Thank you for your understanding!`;
};

export const getRoughCathedralSandDayOneSubject = (order) =>
  `Confirmation Request for Plumbing ROUGH Will Be Ready on ${formatDate(
    order.approvedStartDate,
    DATE_TIME_FORMATS.FORMAT_M_DD
  )}`;

export const getRoughCathedralSandDayOneDetails = (recipients, order) => {
  const recipientNames = getRecipientName(recipients);
  const approvedStartDate = formatDate(
    order.approvedStartDate,
    DATE_TIME_FORMATS.FORMAT_M_DD
  );
  const confirmationDate = formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 1),
    DATE_TIME_FORMATS.FORMAT_M_DD
  );

  return `${recipientNames},\n\nCould you please VERIFY and CONFIRM if the following items will be completed to make the house 100% ready for Plumbing ROUGH on ${approvedStartDate}:
• Water Meter Installed\n• Form Survey Completed\n• Trenching Completed\n\nIn order to keep the ROUGH on the original scheduled date ${approvedStartDate}, please reply via email to ${JOB_READY_EMAIL} by 10AM on ${confirmationDate} to confirm.`;
};

export const getRoughCathedralSandDayTwoSubject = (order) =>
  `Confirmation Request for Plumbing ROUGH Will Be Ready to Move Up to ${formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 1),
    DATE_TIME_FORMATS.FORMAT_M_DD
  )}`;

export const getRoughCathedralSandDayTwoDetails = (recipients, order) => {
  const recipientNames = getRecipientName(recipients);
  const approvedStartDate = formatDate(
    order.approvedStartDate,
    DATE_TIME_FORMATS.FORMAT_M_DD
  );
  const moveUpDate = formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 1),
    DATE_TIME_FORMATS.FORMAT_M_DD
  );
  const confirmationDate = formatDate(
    subtractFromBusinessDate(order.approvedStartDate, 2),
    DATE_TIME_FORMATS.FORMAT_M_DD
  );

  return `${recipientNames},\n\nCould you please VERIFY and CONFIRM if the following items will be completed to make the house 100% ready for Plumbing ROUGH on ${moveUpDate}:
• Water Meter Installed\n• Form Survey Completed\n• Trenching Completed\n\nWe are currently showing this ROUGH scheduled for ${approvedStartDate}.
Please reply via email to ${JOB_READY_EMAIL} by 10AM on ${confirmationDate} to confirm and we will move this ROUGH up to ${moveUpDate} if we have the availability.
<b style="color: red">Confirming READY EARLY does NOT GUARANTEE this home will be MOVED UP from the original schedule date.</b>\n
Thank you for your understanding!`;
};

export const getOrderContactInformation = () =>
  `Please feel free to reach out if you have any questions. Thank you! \n
${JOB_READY_EMAIL}
(972) 446-2500`;
